import html2canvas from "html2canvas";
import jsPDF from "jspdf";

const PDF_BG = "#070b14";

async function _addElementToPdf(pdf, element, isFirst) {
  const canvas = await html2canvas(element, {
    scale: 2,
    useCORS: true,
    backgroundColor: PDF_BG,
    logging: false,
    ignoreElements: (el) => el.classList && el.classList.contains("no-print"),
  });
  const imgData = canvas.toDataURL("image/jpeg", 0.9);
  const pageW = pdf.internal.pageSize.getWidth();
  const pageH = pdf.internal.pageSize.getHeight();
  const imgW = pageW;
  const imgH = (canvas.height * imgW) / canvas.width;

  if (!isFirst) pdf.addPage();
  let heightLeft = imgH;
  let position = 0;
  pdf.addImage(imgData, "JPEG", 0, position, imgW, imgH);
  heightLeft -= pageH;
  while (heightLeft > 0) {
    position -= pageH;
    pdf.addPage();
    pdf.addImage(imgData, "JPEG", 0, position, imgW, imgH);
    heightLeft -= pageH;
  }
}

// Capture one or more DOM elements into a single multi-page A4 PDF.
export async function exportElementsToPdf(elements, filename = "report.pdf") {
  const els = (Array.isArray(elements) ? elements : [elements]).filter(Boolean);
  if (!els.length) return;
  const pdf = new jsPDF({ orientation: "portrait", unit: "mm", format: "a4" });
  for (let i = 0; i < els.length; i++) {
    await _addElementToPdf(pdf, els[i], i === 0);
  }
  pdf.save(filename);
}

export async function exportElementToPdf(element, filename = "report.pdf") {
  return exportElementsToPdf([element], filename);
}
